import { algoListSymbolsMap } from '../../../../partials/AlgosList/Algotable/Cells/CellUnderlyingSymbols';

function getTextAfterUnderlying(text) {
  // Find the index of "underlying:" (case-insensitive)
  const index = text.indexOf('underlying:');

  // Check if "underlying:" is found
  if (index !== -1) {
    // Extract the text after "underlying:"
    // Skip the colon and any following whitespace
    return text
      .slice(index + 'underlying:'.length)
      .trim()
      .toLowerCase();
  } else {
    // "underlying:" not found, return empty string
    return '';
  }
}

export function searchUnderlyingSymbols(underlyings = [], searchTerm = '') {
  let toReturn = false;

  const searchTermFormatted = getTextAfterUnderlying(searchTerm);

  if (!searchTermFormatted) {
    return toReturn;
  }

  for (let index = 0; index < underlyings.length; index++) {
    const element = underlyings[index];
    const elementShort = algoListSymbolsMap[element] || '';

    if (
      element?.toLowerCase()?.startsWith(searchTermFormatted) ||
      (elementShort &&
        elementShort?.toLowerCase()?.startsWith(searchTermFormatted))
    ) {
      toReturn = true;
      break;
    }
  }
  return toReturn;
}
